import React from 'react';
import { Box, Grid, Text } from '@common-fe/common-fe';

import { EmployerPlanStatisticPayload } from '../EmployerStatistics.types';
interface Props {
  value?: EmployerPlanStatisticPayload[];
  limitedUseCount?: number;
}
const DeductibleTrackingHint: React.FC<Props> = ({ value = [], limitedUseCount = 0 }) => {
  return (
    <Box direction="column" gap="spacing16">
      {!!limitedUseCount && (
        <Text size="small" weight={500}>
          Limited use: <Text weight={700}>{limitedUseCount}</Text>
        </Text>
      )}

      {!!value.length && (
        <>
          <Text size="small" weight={500}>
            Deductible tracking:
          </Text>
          <Grid columns="1/2">
            {value.map((item) => (
              <Box direction="column" fill key={item.planId}>
                <Text
                  size="small"
                  truncate
                  title={item.planName}
                  weight={500}
                  margin={{ right: 'spacing12' }}
                >
                  {item.planName}
                </Text>
                {item.tiers.map((tier, index) => (
                  <Text size="small" weight={500} key={`${item.planId}-${index}`}>
                    {' '}
                    {tier.name} - <Text weight={700}>{tier.familyCount}</Text>
                  </Text>
                ))}
              </Box>
            ))}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default DeductibleTrackingHint;
